export default __webpack_public_path__ + "static/media/darkcar.03c4db02.png";